import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { NavigateFunction } from "react-router-dom";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { useEditCameraStore } from "./editCameraStore/editCameraStore";

export const DeleteWebhookDialog = ({
  navigate,
}: {
  navigate: NavigateFunction;
}) => {
  const {
    deleteWebhookDialogOpen,
    setDeleteWebhookDialogOpen,
    setBackdropLoadingScreenEditCameraOn,
    handleDeleteWebhook,
    webhookIdToDelete,
  } = useEditCameraStore();
  return (
    <Dialog open={deleteWebhookDialogOpen}>
      <DialogTitle id="alert-dialog-title">
        {" Are you sure you want to delete this Webhook?"}
      </DialogTitle>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setDeleteWebhookDialogOpen(false);
          }}
          text="Cancel"
          disabled={false}
        />
        <OrangeTextButton
          onClick={() => {
            setBackdropLoadingScreenEditCameraOn(true);
            handleDeleteWebhook(navigate, webhookIdToDelete);
            setDeleteWebhookDialogOpen(false);
          }}
          text="Delete Webhook"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
